module.exports = __webpack_public_path__ + "static/media/shared_icon.83a22555.svg";